import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, notification } from 'tea-component';
import PersonalDataList from './PersonalDataList';
import SourceSteep2 from '@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/addSourceSteep2';
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
import { ITableJoinRelation } from '@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/interface';

export enum Step {
  One,
  Two,
  There,
}

// const AutoReportType = {
//   Template: 'auto_create', // 用模板自动创建报表
//   Table: 'create_table' // 创建空白报表, 图表类型默认是表格
// };

export interface Index {
  close: () => void;
  formatMessage: Function;
  gameCode: string;
  joinTables: IGetTableInfoDto[];
  joinRelations: ITableJoinRelation[];
  getSuccess: Function;
  autoSelectTable: boolean;
  showSelfJoin: boolean;
  isOpenSelfJoin: boolean;
  commonFormatMessage: Function;
  chartType?: string;
  locale: string;
  dispatch: Function;
  isHaveChart: boolean;
  isHaveTables: boolean;
  errorFormatmessage: Function;
}

export default function PersonalDataSource(props: Index) {
  const { formatMessage, close, gameCode, joinTables, joinRelations, getSuccess, showSelfJoin, isOpenSelfJoin, commonFormatMessage, locale, isHaveChart = false, isHaveTables} = props;

  const joinSettingRef = useRef(); // JoinSetting实例

  const [selectTables, setSelectTables] = useState<any[]>([]);

  // selfJoin 是弹窗内部 的自关联状态数据管理; isOpenSelfJoin是多维分析页面model内的自关联状态管理, 只有在提交按钮时可以改变.
  const [selfJoin, setSelfJoin] = useState(isOpenSelfJoin);
  
  // 记录模板id, 用于判断是否自动创建报表
  // 第二步中表信息和字段加载的状态
  const [statusOfStep2, setStatusOfStep2] = useState('');

  const [curStep, setCurStep] = useState<Step>(Step.One); // 目前所处阶段
  useEffect(() => {
    setSelectTables(joinTables.map((item) => ({ table_id: item.table_id, table_name: item.table_name, database_uuid: item.database_uuid, driver: item.driver, db_name: item.db_name,customize_name: item.customize_name,customize_name_en: item.customize_name_en})));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(joinTables)]);
  
  const handleSubmit = async () => {
    const {
      error,
      joinTables,
      joinRelations,
    }: { error: Boolean; joinTables: IGetTableInfoDto[]; joinRelations: ITableJoinRelation[]; } =
      joinSettingRef.current?.getTableInfosAndTableJoinRelations();
    if (error) {
      return;
    }
    
    if (isHaveTables) {
      // 已存在数据源的情况下, 修改数据源, 进行提示
      const result = await Modal.confirm({
        message: formatMessage('confirm_replace_title'),
        description: (<div dangerouslySetInnerHTML={{ __html: formatMessage('confirm_replace_info')}} />),
        okText: commonFormatMessage('confirm'),
        cancelText: commonFormatMessage('cancel'),
        className: 'dbl-datasource-confirm',
        maskStyle: {zIndex: 1001},
      });
      
      if (!result) return;
    }
    
    getSuccess({ joinTables, joinRelations, isOpenSelfJoin: selfJoin });
    notification.success({
      // eslint-disable-next-line no-nested-ternary
      description: selfJoin ? formatMessage("self_join_success") : (joinTables.length === 1) ? formatMessage("add_table") : formatMessage("join_table", { count: joinTables.length })
    });
    close();
  };
  
  return (
    <>
      <Modal.Body >
        <div style={{ display: curStep === Step.One ? '' : 'none' }}>
          <PersonalDataList
            gameCode={gameCode}
            selectTables={selectTables}
            setSelectTables={setSelectTables}
            selfJoin={selfJoin}
            setSelfJoin={setSelfJoin}
          />
        </div>
        <div style={{ display: curStep === Step.Two ? '' : 'none' }}>
          <SourceSteep2
            gameCode={gameCode}
            commonFormatMessage={commonFormatMessage}
            isEn={locale === "en-US"}
            formatMessage={formatMessage}
            ref={joinSettingRef}
            oldJoinTables={joinTables}
            oldJoinRelations={joinRelations}
            curStep={curStep}
            setCurStep={setCurStep}
            selectTables={selectTables}
            setSelectTables={setSelectTables}
            selfJoin={selfJoin}
            setSelfJoin={setSelfJoin}
            showSelfJoin={showSelfJoin}
            setStatusOfStep2={setStatusOfStep2}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="add-Source-footer">
        {
          (curStep === Step.Two) && <Button
            disabled={statusOfStep2 === "loading"}
            type="weak"
            onClick={() => {
              let stepsVal;
              if (isHaveChart) {
                stepsVal = curStep === Step.Two ? Step.One : Step.Two;
              } else {
                stepsVal = Step.One;
              }
              setCurStep(stepsVal);
            }}
          >
            {formatMessage('prev_step')}
          </Button>
        }
        {
          (curStep === Step.One) && <Button
            type="primary"
            onClick={() => {
              setCurStep(Step.Two);
            }}
            disabled={selectTables.length === 0}
          >
            {formatMessage('next_step')}
          </Button>
        }
        {
          (curStep === Step.Two) && <Button
            type="primary"
            /* eslint-disable-next-line @typescript-eslint/no-misused-promises */
            onClick={handleSubmit}
            disabled={selectTables.length === 0}
          >
            {formatMessage('submit')}
          </Button>
        }
      </Modal.Footer>
    </>
  );
}
